<template>
  <div class="testimonial">
    <div class="mb-5 text-center">
      <img
        v-if="testimonial.logo"
        class="d-inline-block my-3 logo"
        :src="testimonial.logo"
      >
      <h5 class="my-2">
        {{ testimonial.name }}
      </h5>
      <small class="role">
        {{ testimonial.role }}
      </small>
    </div>

    <p>
      {{ testimonial.quote }}
    </p>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';

export interface Testimonial {
  name: string;
  role: string;
  logo: string;
  quote: string;
}

export default Vue.extend({
  props: {
    testimonial: {
      type: Object as PropType<Testimonial>,
      required: true,
    },
  },
});
</script>

<style lang="scss" scoped>
@import '~@/scripts/pages/onepager/styles/variables-entry';

.testimonial {
  $shadow-width: 4px;

  background: white;
  padding: $grid-gutter-width / 2;
  margin-top: $shadow-width;
  margin-bottom: $shadow-width;
  box-shadow: 1px 1px #{$shadow-width} 0px rgba(0,0,0,0.1);
  border-radius: 0.5em;
}

.logo {
  $logo-size: 4em;
  width: $logo-size;
  height: $logo-size;
  border-radius: $logo-size / 2;
  background-color: lightgray;
}

p {
  font-style: italic;
}
.role {
  line-height: 1.5;
  display: inline-block;
  margin-top: 0.5em;
  min-height: 30px;
}
</style>
